import { combineReducers } from "redux";
import { brandsEntriesReducer } from "modules/Brands/services/Brands/reducer";

export const brandsReducer = combineReducers({ entries: brandsEntriesReducer });